<template>


        <div class="item" style="background:#FFF;border-radius:5px;font-size:10pt;border:solid 1px #e5e5e5;padding:15px;padding-bottom:5px;">
            

            <div style="margin-bottom:15px;min-height:28px;">
                <div style="">
                <img v-if="item.__cliente.logo!=null" style="height:28px;float:right;max-width:95px;" :src="'https://s3.amazonaws.com/aet.gestor/'+item.__cliente.logo.arquivo" alt="">
                </div>
                <div style="font-weight:600;font-size:9pt;line-height:120%;padding-top:3px;">
                    {{ Apelido(item.__cliente.nome, item.__cliente.apelido) }}
                    <br><span style="font-size:7pt;">Por Cristyan Marcos</span>
                </div>
                
            </div>

            <div v-for="(item, index) in item.items" v-bind:key="index" class="items" style="display:none;">
                <div style="font-size:11pt;font-weight:800;">{{item.unidade_tratora}}</div>
                <div style="font-weight:500;font-size:8pt;color:#666">{{item.tipo.text}} {{item.conjunto.pbtc}}t, {{item.conjunto.comprimento}}m</div>
            </div>


            <div>
                <div style="font-size:9pt;font-weight:600;margin-top:5px;">{{CountAets(item.items)}} Autorizações ({{ item._tipo }})</div>
                <div class="progress" style="height:3px;margin-top:2px;margin-bottom:2px;">
                    <div class="progress-bar" role="progressbar" style="width: 2%" aria-valuenow="2" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
    
           <div style="margin-top:5px;">
            <div>

                <div style="">
                    <small style="color:#666;font-size:8pt;">{{ item.dt + ' por '}}</small>
                </div>
            </div>
           </div>

        </div>

    
</template>

<script>
import Vue from 'vue'
export default {
    name:"pedido",
    props:{
        data:{
            required:true
        },

    },
    data(){
        return{
            item:{}
        }
    },
    methods: {
        log: function(evt) {
            window.console.log(evt);
        },
        Apelido(nome, apelido){
            if(apelido!=null && apelido!=''){
                
                return Vue.filter('truncate')(apelido,23)
            }else{
                return Vue.filter('truncate')(nome,23)
            }
        },

        CountAets(items){
            let n = 0
            items.forEach(i => {

                i.items.forEach(aet => {
                    console.log(aet)
                    n++;
                })

            });
            return n
        }

    },
    beforeMount(){
        this.item = this.$props.data
    }
}
</script>

<style scoped>
    .items{
        border-bottom: dashed 1px #ebebeb;
        margin-bottom: 10px;
    }

    .items:last-child{
        border-bottom: 0px;
    }
</style>